import { SideItems } from './sidebarItems';
import { IMenuItem, ISidebarItem, MENU_ROUTE_PARAM, RouteParams } from './types.d';

/**
 * Get sidebar item from route params
 */
export const getSidebarItem = (params: RouteParams): ISidebarItem | null => {
  const { section } = params;
  return SideItems.find((item) => item.routeParam === section) || null;
};

/**
 * Get menu item from route params
 */
export const getMenuItem = (params: RouteParams): IMenuItem | null => {
  const { subsection } = params;
  const sidebarItem = getSidebarItem(params);

  if (subsection) {
    return sidebarItem?.subItems?.find((item) => item.routeParam === subsection) || null;
  }

  return sidebarItem;
};

/**
 * Get menu item type from route params
 */
export const getMenuItemType = (params: RouteParams): string => {
  const sidebarItem = getSidebarItem(params);
  const menuItem = getMenuItem(params);
  return menuItem?.type || sidebarItem?.type || sidebarItem?.subItems?.[0]?.type || '';
};

/**
 * Get menu item path from route params
 */
export const getMenuItemPath = (section?: string, subsection?: string): string => {
  if (!section) {
    return `/service-manager/${MENU_ROUTE_PARAM.USERS}`;
  }

  if (subsection) {
    return `/service-manager/${section}/${subsection}`;
  }

  return `/service-manager/${section}`;
};

/**
 * Validate menu item path from route params
 */
export const validateMenuItemPath = (path: string, params: RouteParams): boolean => {
  const { section, subsection } = params;
  const itemPath = `${getMenuItemPath(section, subsection)}/`;
  const pathWithSlash = `${path}/`;
  return pathWithSlash.includes(itemPath);
};
